import TopNav from "./topnav";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";

const MainLayout = () => {
    return (
        <div className="flex flex-col bg-gray-50 h-screen overflow-hidden">
            {/* Top Navigation Bar */}
            <div className="sticky top-0 z-50 flex-shrink-0">
                <TopNav />
            </div>
            
            {/* Main Content Area with Sidebar */}
            <div className="flex flex-1 min-w-0 overflow-hidden h-full">
                {/* Sidebar */}
                <Sidebar />
                
                {/* Main Content - Scrollable */}
                <main className="flex-1 bg-gray-50 overflow-auto">
                    <div className="p-4 md:p-6 max-w-full">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default MainLayout;
